"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "potenza": {
    "d18b42a8": [{
      "hkey": "451389fe",
      "slug": "francioso-liberta-montereale-via-dante",
      "name": "Francioso-Libertà-Montereale-Via Dante",
      "primary": true,
      "skipSearch": false
    }],
    "francioso": [{
      "hkey": "451389fe",
      "slug": "francioso-liberta-montereale-via-dante",
      "name": "Francioso-Libertà-Montereale-Via Dante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "22d0a7ad": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-romana-cooperativa": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cc9d464": [{
      "hkey": "abce3115",
      "slug": "macchia-romana-parco-aurora",
      "name": "Macchia Romana-Parco Aurora",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-romana-edilizia-privata": [{
      "hkey": "abce3115",
      "slug": "macchia-romana-parco-aurora",
      "name": "Macchia Romana-Parco Aurora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e06d30f3": [{
      "hkey": "abce3115",
      "slug": "macchia-romana-parco-aurora",
      "name": "Macchia Romana-Parco Aurora",
      "primary": true,
      "skipSearch": false
    }],
    "parco-aurora": [{
      "hkey": "abce3115",
      "slug": "macchia-romana-parco-aurora",
      "name": "Macchia Romana-Parco Aurora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "potenza"
    }],
    "e136bc5e": [{
      "hkey": "23383266",
      "slug": "poggio-tre-galli-via-del-gallitello",
      "name": "Poggio Tre Galli-Via del Gallitello",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-tre-galli": [{
      "hkey": "23383266",
      "slug": "poggio-tre-galli-via-del-gallitello",
      "name": "Poggio Tre Galli-Via del Gallitello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d4c838c9": [{
      "hkey": "74bf6aac",
      "slug": "lucania-santa-croce",
      "name": "Lucania-Santa Croce",
      "primary": true,
      "skipSearch": false
    }],
    "rione-lucania": [{
      "hkey": "74bf6aac",
      "slug": "lucania-santa-croce",
      "name": "Lucania-Santa Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "potenza"
    }],
    "67873da3": [{
      "hkey": "9e75a77b",
      "slug": "santa-maria-verderuolo-via-mazzini",
      "name": "Santa Maria-Verderuolo-Via Mazzini",
      "primary": true,
      "skipSearch": false
    }],
    "rione-mancusi": [{
      "hkey": "9e75a77b",
      "slug": "santa-maria-verderuolo-via-mazzini",
      "name": "Santa Maria-Verderuolo-Via Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "potenza"
    }],
    "a1824761": [{
      "hkey": "74bf6aac",
      "slug": "lucania-santa-croce",
      "name": "Lucania-Santa Croce",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "74bf6aac",
      "slug": "lucania-santa-croce",
      "name": "Lucania-Santa Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1999b6e3": [{
      "hkey": "d4e74e5c",
      "slug": "betlemme-san-rocco",
      "name": "Betlemme-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "d4e74e5c",
      "slug": "betlemme-san-rocco",
      "name": "Betlemme-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "213581de": [{
      "hkey": "23383266",
      "slug": "poggio-tre-galli-via-del-gallitello",
      "name": "Poggio Tre Galli-Via del Gallitello",
      "primary": true,
      "skipSearch": false
    }],
    "via-del-gallitello": [{
      "hkey": "23383266",
      "slug": "poggio-tre-galli-via-del-gallitello",
      "name": "Poggio Tre Galli-Via del Gallitello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "potenza"
    }],
    "ae036a75": [{
      "hkey": "9e75a77b",
      "slug": "santa-maria-verderuolo-via-mazzini",
      "name": "Santa Maria-Verderuolo-Via Mazzini",
      "primary": true,
      "skipSearch": false
    }],
    "via-mazzini": [{
      "hkey": "9e75a77b",
      "slug": "santa-maria-verderuolo-via-mazzini",
      "name": "Santa Maria-Verderuolo-Via Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fd41854e": [{
      "hkey": "451389fe",
      "slug": "francioso-liberta-montereale-via-dante",
      "name": "Francioso-Libertà-Montereale-Via Dante",
      "primary": true,
      "skipSearch": false
    }],
    "viale-dante": [{
      "hkey": "451389fe",
      "slug": "francioso-liberta-montereale-via-dante",
      "name": "Francioso-Libertà-Montereale-Via Dante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "potenza"
    }],
    "6e593616": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "skipSearch": false
    }],
    "zona-g": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f492a0a7": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "skipSearch": false
    }],
    "zona-rurale": [{
      "hkey": "bb691126",
      "slug": "potenza",
      "name": "Potenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;